/** ホーム入場時の足跡ローディング進行。Mobile `AssistantCatHomeLoadingProgress` と同じ。 */
export class AssistantCatHomeLoadingProgress {
  readonly stepIntervalMs = 500;

  readonly maxPawCount = 3;

  pawCount = 0;

  minCycleCompleted = false;

  imagesReady = false;

  identityReady = false;

  finished = false;

  onTick(): boolean {
    if (this.finished) {
      return true;
    }

    if (!this.minCycleCompleted) {
      if (this.pawCount < this.maxPawCount) {
        this.pawCount += 1;
      } else {
        this.minCycleCompleted = true;
        if (this.tryFinish()) {
          return true;
        }
        this.pawCount = 1;
      }
      return false;
    }

    this.pawCount = this.pawCount >= this.maxPawCount ? 1 : this.pawCount + 1;
    return this.tryFinish();
  }

  markImagesReady(): void {
    this.imagesReady = true;
    this.tryFinish();
  }

  markIdentityReady(): void {
    this.identityReady = true;
    this.tryFinish();
  }

  reset(): void {
    this.pawCount = 0;
    this.minCycleCompleted = false;
    this.imagesReady = false;
    this.identityReady = false;
    this.finished = false;
  }

  forceFinish(): void {
    this.imagesReady = true;
    this.identityReady = true;
    this.minCycleCompleted = true;
    this.finished = true;
  }

  private tryFinish(): boolean {
    if (this.finished) {
      return true;
    }
    if (this.imagesReady && this.identityReady && this.minCycleCompleted) {
      this.finished = true;
      return true;
    }
    return false;
  }
}
